import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./content-menu.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./content-menu.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UserInformationService } from "../../services/user/user-information.service";
import { AflaModuleStrategyService } from "../../services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AppControllerService } from "../../../app-controller.service";
import { ViewApplicationService } from "../../../application/view-application/view-application.service";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
let ContentMenuComponent = class ContentMenuComponent {
    router;
    moduleStrategyService;
    userInformationService;
    viewApplicationService;
    route;
    appControllerService;
    pageHeading;
    menuItems;
    relativeLinks = true;
    selectedModule;
    selectedModuleName = "";
    selectedOrganisationName = "";
    checkStateSubscription;
    currentTitlesObservableSubscription;
    constructor(router, moduleStrategyService, userInformationService, viewApplicationService, route, appControllerService) {
        this.router = router;
        this.moduleStrategyService = moduleStrategyService;
        this.userInformationService = userInformationService;
        this.viewApplicationService = viewApplicationService;
        this.route = route;
        this.appControllerService = appControllerService;
        this.pageHeading = this.moduleStrategyService.dynamicTitle.CreateApplicationTitle;
        this.selectedModule = this.userInformationService.getModuleInformation(+this.appControllerService.selectedModuleID);
        this.selectedModuleName = this.selectedModule?.name;
        this.selectedOrganisationName = this.selectedModule?.organisation?.name;
        this.checkState();
    }
    ngOnInit() {
        this.currentTitlesObservableSubscription = this.viewApplicationService.$currentTitlesObservable.subscribe(t => {
            if (t)
                this.pageHeading = t.CreateApplicationTitle;
        });
    }
    routeToMenuItem(menuItem) {
        if (this.relativeLinks) {
            this.router.navigate([menuItem.address], { relativeTo: this.route });
        }
        else {
            this.router.navigate([menuItem.address]);
        }
    }
    checkState() {
        if (this.menuItems && this.pageHeading) {
            return;
        }
        this.checkStateSubscription = this.route.data
            .subscribe((data) => {
            this.menuItems = data.menuItems;
            if (!this.pageHeading)
                this.pageHeading = data.pageHeading;
        });
    }
    onActivate() {
        document.querySelector(".content").scrollTo(0, 0);
    }
    static ctorParameters = () => [
        { type: Router },
        { type: AflaModuleStrategyService },
        { type: UserInformationService },
        { type: ViewApplicationService },
        { type: ActivatedRoute },
        { type: AppControllerService }
    ];
    static propDecorators = {
        pageHeading: [{ type: Input }],
        menuItems: [{ type: Input }],
        relativeLinks: [{ type: Input }]
    };
};
ContentMenuComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-content-menu",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ContentMenuComponent);
export { ContentMenuComponent };
